import { memo } from 'react';

/**
 * Skeleton pour la barre de recherche et filtres
 */
const SearchFiltersSkeleton = memo(() => {
  return (
    <div className="search-filter-container mb-3">
      <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
        
        {/* Titre skeleton */}
        <div className="d-flex align-items-center gap-2">
          <div className="skeleton-shimmer-circle" style={{ width: '20px', height: '20px' }} />
          <div className="skeleton-shimmer-bar" style={{ width: '80px', height: '20px' }} />
        </div>
        
        {/* Contrôles skeleton */}
        <div className="filter-controls d-flex flex-wrap align-items-center gap-2">
          {/* Barre de recherche */}
          <div className="skeleton-shimmer-bar" style={{ 
            width: '380px', 
            height: '38px', 
            borderRadius: '4px' 
          }} />
          
          {/* Filtres */}
          {[150, 130, 80, 80, 130].map((width, i) => (
            <div 
              key={i}
              className="skeleton-shimmer-bar" 
              style={{ 
                width: `${width}px`, 
                height: '38px', 
                borderRadius: '4px',
                animationDelay: `${i * 0.1}s`
              }} 
            />
          ))}
        </div>
      </div>

      <style>{`
        .skeleton-shimmer-circle,
        .skeleton-shimmer-bar {
          background: linear-gradient(
            90deg,
            #f0f0f0 0%,
            #e0e0e0 50%,
            #f0f0f0 100%
          );
          background-size: 200% 100%;
          animation: shimmer 1.5s ease-in-out infinite;
        }

        .skeleton-shimmer-circle {
          border-radius: 50%;
        }

        .skeleton-shimmer-bar {
          border-radius: 4px;
        }

        @keyframes shimmer {
          0% { background-position: -200% 0; }
          100% { background-position: 200% 0; }
        }

        @media (max-width: 768px) {
          .filter-controls .skeleton-shimmer-bar {
            width: 100% !important;
          }
        }
      `}</style>
    </div>
  );
});

SearchFiltersSkeleton.displayName = 'SearchFiltersSkeleton';

export default SearchFiltersSkeleton;